import { render, staticRenderFns } from "./tuozhanshebei.vue?vue&type=template&id=f97ed594&scoped=true&"
import script from "./tuozhanshebei.vue?vue&type=script&lang=js&"
export * from "./tuozhanshebei.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/tuozhanshebei.less?vue&type=style&index=0&id=f97ed594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ed594",
  null
  
)

component.options.__file = "tuozhanshebei.vue"
export default component.exports